/**
 * Assignments stored before the qualifiers became lowercase hold the
 * original uppercase values.
 */
const LEGACY_QUALIFIERS = {
    "MUST": "must",
    "AT_LEAST_1": "at-least-one",
    "RECOMMENDED": "recommended",
    "MAY": "may",
};
/**
 * @returns The current qualifier for a legacy uppercase one, otherwise the
 * value as it is.
 */
export function normalizeQualifier(value) {
    return LEGACY_QUALIFIERS[value] ?? value;
}
export const CONTROLLED_VOCABULARY_ASSIGNMENT = "controlled-vocabulary-assignment";
export function isControlledVocabularyAssignment(entity) {
    return entity?.type.includes(CONTROLLED_VOCABULARY_ASSIGNMENT) ?? false;
}
/**
 * @returns The entity with a legacy qualifier replaced, see
 * {@link normalizeQualifier}. Anything that is not a controlled vocabulary
 * assignment with a legacy qualifier is returned as it is.
 */
export function normalizeLegacyAssignment(entity) {
    if (!isControlledVocabularyAssignment(entity)) {
        return entity;
    }
    const qualifier = normalizeQualifier(entity.qualifier);
    return qualifier === entity.qualifier ? entity : { ...entity, qualifier };
}
//# sourceMappingURL=controlled-vocabulary-assignment.js.map